var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PanelRow",
    { staticClass: "graphview" },
    [
      _c(
        "div",
        { staticClass: "panel controls compact" },
        [
          _c("DeviceSelector", {
            attrs: { devices: _vm.available_devices },
            model: {
              value: _vm.chosen_ids,
              callback: function($$v) {
                _vm.chosen_ids = $$v
              },
              expression: "chosen_ids"
            }
          }),
          _vm._v(" "),
          _c("IntervalSelector", {
            on: { reload: _vm.reload },
            model: {
              value: _vm.time_interval,
              callback: function($$v) {
                _vm.time_interval = $$v
              },
              expression: "time_interval"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.graphs, function(graph, i) {
        return _c(
          "div",
          {
            ref: "graph-" + i,
            refInFor: true,
            staticClass: "panel compact graph-holder",
            class: { fullscreen: _vm.fullscreen === i }
          },
          [
            _c(
              "header",
              [
                _c("h2", [_vm._v(_vm._s(_vm._f("text")(graph.type.title)))]),
                _vm._v(" "),
                _c("Icon", {
                  attrs: {
                    name: _vm.fullscreen ? "fullscreen_exit" : "fullscreen",
                    title: _vm.$t("feelgrid:puredata.fullscreen")
                  },
                  nativeOn: {
                    click: function($event) {
                      _vm.go_fullscreen(_vm.fullscreen ? false : i)
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            graph.datasets === "loading"
              ? _c("Loading", { staticClass: "graph-loader" })
              : graph.datasets
                ? _c("Graph", {
                    attrs: { graph: graph, interval: _vm.graph_interval }
                  })
                : _c("label", [
                    _vm._v(_vm._s(_vm._f("trans")("feelgrid:no_data")))
                  ])
          ],
          1
        )
      }),
      _vm._v(" "),
      !Object.keys(_vm.graphs).length
        ? _c("div", { staticClass: "panel user-help" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm._f("trans")("feelgrid:puredata.select_device")) +
                "\n  "
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d27512d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d27512d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/feelgrid/modules/pureData/GraphView.vue
// module id = null
// module chunks = 